'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var connect = require('react-redux').connect;
var PreviewMixin = require('./Mixin/Preview.jsx');
var storeHelper = require('../helper/storeHelper');

var Actions = require('../actions/AppActions');

var PreviewPanel = require('./PreviewPanel.jsx');
var Workspace = require('./Workspace.jsx');
var RenderTimePanel = require('./Dev/RenderTimePanel');
var TestProjects = require('./Dev/TestProjects');
var NavigationBar = require('./NavigationBar');
var PageRemark = require('./PageRemark');
var SignCheckAlert = require('./Review/SignCheckAlert.jsx');
var PagePaint = require('./PagePaint');
var ErrorMessage = require('./ErrorMessage');
var AppReviews = require('./AppReviews');

var deviceShellHelper = require('../helper/deviceShellHelper');
var colorHelper = require('../helper/colorHelper');
var assetsHelper = require('../helper/assetsHelper');
var configHelper = require('../helper/configHelper');
var domHelper = require('../helper/domHelper');
var cacheHelper = require('../helper/cacheHelper');
var pageHelper = require('../helper/pageHelper');
var urlHelper = require('../helper/urlHelper');
var runtimeHelper = require('../helper/runtimeHelper');
var i18nHelper = require('../helper/i18n');

var PCPreview = React.createClass({
  propTypes: {
    app: React.PropTypes.object,
    current: React.PropTypes.object,
    target: React.PropTypes.object,
    path: React.PropTypes.string.isRequired,
    animation: React.PropTypes.object,
    pages: React.PropTypes.object,
    review: React.PropTypes.object,
    comments: React.PropTypes.array,
    onLoadApp: React.PropTypes.func.isRequired,
    onFinishOpenPage: React.PropTypes.func.isRequired,
    onLoadReviewData: React.PropTypes.func.isRequired,
    onAddReview: React.PropTypes.func.isRequired
  },
  mixins: [PreviewMixin],
  getInitialState: function () {
    var config = this.props.config;
    var platform = this.props.app.params.projectParam.platform;
    var isSign = false;
    var author = '';
    if (storeHelper.get('sign') && storeHelper.get('sign') !== 'null') {
      isSign = true;
      author = storeHelper.get('sign');
    }

    var t = urlHelper.getQueryString('t'); // 模式，如果 t=r 显示评论和备注，如果 t=c 自动进入批注模式

    return _.extend(config, {
      scale: 1,
      canFix: platform === 'MtMobile' || platform === 'MtPad',
      shell: deviceShellHelper.getShellInfoByPlatform(this.props.app.params.projectParam.platform, config.shell),
      controlPanel: config.showControlPanel,
      domSize: domHelper.getDocumentSize(),
      showRemark: t === 'r',
      isCommentMode: t === 'c', //是否批注模式
      showAppReviews: false, // 是否显示项目批注
      isSign: isSign,
      author: author,
      pageNeedRerender: true, // 只有该值为 true 时页面内容才会得到更新，这不是一个好办法，但是目前来说，页面内的数据不能轻易被刷新，否则会引起交互错误，必须这样处理
    });
  },
  componentDidMount: function () {
    this.props.onLoadApp(this.props.app);
    domHelper.onDocumentResize(this.onDomSizeChange);
  },
  componentWillUnmount: function () {
    domHelper.offDocumentResize(this.onDomSizeChange);
  },
  componentDidUpdate: function () {
    if (this.state.pageNeedRerender) { // 如果该值为 true, 渲染完成后立即重置为 false
      this.setState({
        pageNeedRerender: false
      });
    }
  },
  componentWillReceiveProps: function (nextProps, nextState) {
    var currentID = this.props.current && this.props.current.ID;
    var nextID = nextProps && nextProps.target && nextProps.target.ID;
    this.setState({
      pageNeedRerender: currentID !== nextID
    }); // 当页面ID不同时才重新渲染
  },
  getClassNameOfWrapper: function () {
    var className = 'app';

    if (this.state.alwaysShowLinks) {
      className += ' always-show-links';
    } else if (this.state.hoverShowLinks) {
      className += ' hover-show-links';
    }
    if (this.state.hoverShowRemarks) {
      className += ' hover-show-remarks';
    }
    return className;
  },
  /**
   * 获取当前页面的备注信息
   * @returns {string}
   */
  getCurrentPageRemark: function () {
    var current;
    var param;
    var text;
    current = this.props.current;
    if (!current) {
      return i18nHelper.get('NO_REMARK');
    }
    param = current.param;
    if (!param || !param[0]) {
      return i18nHelper.get('NO_REMARK');
    }
    text = param[0].remark;
    if (typeof text !== 'string') {
      return i18nHelper.get('NO_REMARK');
    }
    return decodeURI(text);
  },
  render: function () {
    var className;
    var syncID = window.reviewID || '';
    var syncRevision = window.revision || -1;
    if (!this.props.current) {
      return this.renderLoading();
    }
    var pageNameTree = this.getPageName();
    if (this.state.isCommentMode) { // 进入了批注模式
      return this.renderCommentMode(pageNameTree);
    }
    className = this.getClassNameOfWrapper();

    if (this.props.error) {
      console.log('error msg:' + this.props.error);
    }

    if (this.onClearErrorProxy === null) {
      this.onClearErrorProxy = this.props.onClearError;
    }

    return (
      <div className={className} style={{
        backgroundColor: this.state.background
      }}>
        <ErrorMessage error={this.props.error}
                      onClearError={this.onClearErrorProxy}
        />
        {
          runtimeHelper.canReview() && this.state.showAppReviews &&
          <AppReviews
            name={this.props.app.name}
            syncID={syncID}
            projectReviews={this.props.appReviews}
            onLoadProjecReviews={this.props.onLoadProjectReviews}
            onCloseAppReviews={this.onToggleAppReviews}
          />
        }
        <NavigationBar
          domSize={this.state.domSize}
          onOpenHome={this.onOpenHome}
          onOpenNext={this.onOpenNext}
          onOpenPrev={this.onOpenPrev}
          onPlayback={this.onPlayback}
          controlPanel={this.state.controlPanel}
          onTogglePanelVisibility={this.onTogglePanelVisibility}
          onToggleRemarkVisibility={this.onToggleRemarkVisibility}
          onToggleCommentMode={this.onToggleCommentMode}
        />
        {window.isDev && <TestProjects openApp={this.openApp}/> }
        {this.state.controlPanel &&
        <PreviewPanel
          domSize={this.state.domSize}
          app={this.props.app}
          current={this.props.current}
          scale={this.state.scale}
          shell={this.state.shell}
          showComments={this.state.showComments}
          alwaysShowLinks={this.state.alwaysShowLinks}
          hoverShowLinks={this.state.hoverShowLinks}
          hoverShowRemarks={this.state.hoverShowRemarks}
          showPanel={this.state.showControlPanel}
          showQRCode={this.state.showQRCode}
          onOpenPage={this.onOpenPage}
          onScaleChange={this.onScaleChange}
          onShowComments={this._onShowComments}
          onShowReview={this._onShowReview}
          onAlwaysShowLinks={this.onAlwaysShowLinks}
          onHoverShowLinks={this.onHoverShowLinks}
          onHoverShowRemarks={this.onHoverShowRemarks}
          onSetPanelVisibility={this.onSetPanelVisibility}
          showCommentsBoard={this.onToggleAppReviews}
          showQrCode={this.props.config.showQRCode}
        />
        }
        {this.props.current &&
        <Workspace
          domSize={this.state.domSize}
          meta={this.props.meta}
          pages={this.props.pages}
          current={this.props.current}
          target={this.props.target}
          animation={this.props.animation}
          app={this.props.app}
          scale={this.state.scale}
          shell={this.state.shell}
          showComments={this.state.showComments}
          canFix={this.state.canFix}
          onShowRemark={this.onShowRemark}
          onRedirectTo={this.onRedirectTo}
          onOpenPage={this.onOpenPage}
          onFinishOpenPage={this.onFinishOpenPage}
          alwaysShowLinks={this.state.alwaysShowLinks}
          hintLinks={this.state.hintLinks}
          scrollRemarks={this.state.scrollRemarks}
          pageNeedRerender={this.state.pageNeedRerender}
          isCommentMode={false}
        />
        }
        <div className="remark" ref="remark"></div>
        <PageRemark name={this.props.current.title}
                    syncID={syncID}
                    syncVersion={syncRevision}
                    page={this.props.current}
                    pageName={pageNameTree}
                    remark={this.getCurrentPageRemark()}
                    show={this.state.showRemark}
                    onClose={this.onToggleRemarkVisibility}
                    onAddComment={this.props.onAddComment}
                    onLoadComment={this.props.onLoadComment}
                    isSign={this.state.isSign}
                    author={this.state.author}
                    sign={this.sign}
                    removeSign={this.removeSign}
                    comments={this.props.comments}
                    onError={this.onErrorFilter}
                    onClearError={this.props.onClearError}
        />
        {window.debug && <RenderTimePanel/> }
      </div>
    );
  },

  renderLoading: function () {
    var logoPath = this.state.logo;
    return (
      <div className="preview-loading">
        <img width="120" height="120" src={logoPath} alt="Mockplus"/>
      </div>
    );
  },

  renderCommentMode: function (pageNameTree) {
    var syncID = window.reviewID || '';
    var syncRevision = window.revision || -1;
    return (
      <PagePaint
        syncID={syncID}
        syncVersion={syncRevision}
        pageName={pageNameTree}
        review={this.props.review}
        shell={this.state.shell}
        domSize={this.state.domSize}
        meta={this.props.meta}
        scale={this.state.scale}
        page={this.props.current}
        onExitPaint={this.onToggleCommentMode}
        isSign={this.state.isSign}
        sign={this.sign}
        onLoadReviewData={this.props.onLoadReviewData}
        onAddReview={this.props.onAddReview}
        onUpdateReview={this.props.onUpdateReview}
        onRemoveReview={this.props.onRemoveReview}
        error={this.props.error}
        onError={this.props.onError}
        onClearError={this.props.onClearError}
        background={this.state.background}
      />
    );
  },

  getPageName: function () {
    var pages = this.props.app.pages;
    var current = this.props.current;
    var result = this.searchTree(pages, current.ID);
    return result;
  },
  searchTree: function (root, ID) {
    if (!root || !root._pages) {
      return '';
    }
    for (var i = 0; i < root._pages.length; i++) {
      var page = root._pages[i];
      if (ID === page.ID) {
        return page.name;
      }
      var result = this.searchTree(page, ID);
      if (result) {
        return page.name + '/' + result;
      }
    }
    return '';
  },

  onClearErrorProxy: null,
  //此处加入error消息确定后的回调
  onErrorFilter: function (msg, clearCallback) {
    if (clearCallback) {
      this.onClearErrorProxy = clearCallback;
    } else {
      this.onClearErrorProxy = this.props.onClearError;
    }
    this.props.onError(msg);
  },

  openApp: function (p) {
    storeHelper.set('path', p);
    window.location.reload();
  },

  onDomSizeChange: function () {
    this.setState({
      domSize: domHelper.getDocumentSize()
    });
  },
  _onShowComments: function (show) {
    this.setState({
      showComments: show
    });
  },
  _onShowReview: function (show) {
    this.setState({
      showReview: show
    });
  },
  onScaleChange: function (scale) {
    this.setState({
      scale: scale
    });
  },
  onAlwaysShowLinks: function (show) {
    this.setState({
      alwaysShowLinks: show
    });
  },
  onHoverShowLinks: function (show) {
    this.setState({
      hoverShowLinks: show
    });
  },
  onHoverShowRemarks: function (show) {
    this.setState({
      hoverShowRemarks: show
    });
  },
  onShowRemark: function (x, y, remark) {
    if (this.state.hoverShowRemarks) {
      var dom = ReactDOM.findDOMNode(this.refs.remark);
      if (remark) {
        dom.style.left = x + 12 + 'px';
        dom.style.top = y + 12 + 'px';
        dom.style.display = 'block';
        dom.innerHTML = remark.replace(/\n/g, '<br/>');
      } else {
        dom.style.display = 'none';
      }
    }
  },
  onSetPanelVisibility: function (visible) {
    this.setState({
      showControlPanel: visible
    });
  },
  onTogglePanelVisibility: function () {
    this.setState({
      showControlPanel: !this.state.showControlPanel
    });
  },
  onToggleRemarkVisibility: function () {
    this.setState({
      showRemark: !this.state.showRemark
    });
  },
  onToggleCommentMode: function () {
    this.setState({
      isCommentMode: !this.state.isCommentMode
    });
  },
  sign: function (author) {
    storeHelper.set('sign', author);
    this.setState({
      isSign: true,
      author: author,
    });
  },
  removeSign: function () {
    storeHelper.set("sign", 'null');
    this.setState({
      isSign: false,
    });
  },
  onToggleAppReviews: function () {
    this.setState({
      showAppReviews: !this.state.showAppReviews
    });
  },
  onFinishOpenPage: function () {
    this.props.onFinishOpenPage(this.props.target);
  },
});

function mapStateToProps(state) {
  cacheHelper.cache(cacheHelper.keys.PROJECT_VERSION, state.app && state.app.params.projectParam.version);
  cacheHelper.cache(cacheHelper.keys.PAGE_VERSION, state.current && state.current.version);
  cacheHelper.cache(cacheHelper.keys.PLATFORM, state.app && state.app.params.projectParam.platform);
  return {
    app: state.app,
    meta: state.app && state.app.params.projectParam,
    current: state.current,
    target: state.target,
    animation: state.animation,
    config: state.config,
    projectVersion: state.app && state.app.params.projectParam.version,
    pageVersion: state.current && state.current.version,
    review: state.review,
    comments: state.comments,
    error: state.error,
    appReviews: state.appReviews,
    rnd: Math.random() //FIXME: damn it, there is a bug, clone project cannot trigger component update, I have to add this random number to fix it
  };
}
var isSkiping = false;    //标志在执行页面跳转中
function mapDispatchToProps(dispatch) {
  return {
    onLoadApp: function (app) {
      dispatch(Actions.loadApp(app));
    },

    onOpenPage: function (id) {
      if(!isSkiping) {
        dispatch(Actions.openPage(id));
      }
    },
    onFinishOpenPage: function (targetPage) {
      if(isSkiping) {
        isSkiping = false;
        dispatch(Actions.finishOpenPage(targetPage));
      }
    },
    onRedirectTo: function (id, animation) {
      //只响应一次切换页面请求
      //必须保证调用onFinishOpenPage形成isSkiping闭环
      if(!isSkiping) {
        isSkiping = true;
        dispatch(Actions.redirectPage(id, animation));
      }
    },
    onLoadReviewData: function (syncID, syncVersion, pageID) {
      dispatch(Actions.loadReviewData(syncID, syncVersion, pageID));
    },
    onAddReview: function (syncID, syncVersion, pageID, pageName, author, data) {
      dispatch(Actions.addReview(syncID, syncVersion, pageID, pageName, author, data));
    },
    onAddComment: function (syncID, syncVersion, pageID, pageName, author, content) {
      dispatch(Actions.addComment(syncID, syncVersion, pageID, pageName, author, content));
    },
    onLoadComment: function (syncID, syncVersion, pageID) {
      dispatch(Actions.loadComment(syncID, syncVersion, pageID));
    },
    onUpdateReview: function (syncID, syncVersion, pageID, author, id, data) {
      dispatch(Actions.updateReview(syncID, syncVersion, pageID, author, id, data));
    },
    onRemoveReview: function (syncID, syncVersion, pageID, author, id) {
      dispatch(Actions.removeReview(syncID, syncVersion, pageID, author, id));
    },
    onError: function (error) {
      dispatch(Actions.showError(error));
    },
    onClearError: function () {
      dispatch(Actions.clearError());
    },
    onLoadProjectReviews: function (syncID) {
      dispatch(Actions.loadProjectReviews(syncID));
    }
  };
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(PCPreview);



// WEBPACK FOOTER //
// ./src/views/PCPreview.jsx